import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../dashboard/PageShell";
import { Plus, Trash2, ArrowLeft } from "lucide-react";

interface CouncilMember {
  id: number;
  selectedMember: string;
  memberName: string;
  role: string;
}

const AddCouncilMember: React.FC = () => {
  const navigate = useNavigate();
  const [members, setMembers] = useState<CouncilMember[]>([
    {
      id: 1,
      selectedMember: "",
      memberName: "",
      role: "",
    },
  ]);

  const handleInputChange = (
    index: number,
    field: keyof CouncilMember,
    value: string
  ) => {
    setMembers((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const addMember = () => {
    const newMember: CouncilMember = {
      id: members.length + 1,
      selectedMember: "",
      memberName: "",
      role: "",
    };
    setMembers([...members, newMember]);
  };

  const removeMember = (index: number) => {
    if (members.length > 1) {
      setMembers(members.filter((_, i) => i !== index));
    }
  };

  const handleSave = () => {
    console.log("Saving council members:", members);
    // TODO: Implement save functionality
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <PageShell title="Thêm thành viên hội đồng">
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3 min-w-0">
            <button
              onClick={handleGoBack}
              aria-label="Go back"
              className="p-3 rounded-full text-[#337ab7] bg-blue-50 hover:bg-blue-100 transition-colors"
            >
              <ArrowLeft className="h-5 w-5" />
            </button>
            <h1 className="text-lg font-semibold text-gray-800 truncate">
              Thêm thành viên hội đồng
            </h1>
          </div>
        </div>

        {/* Council Information Section */}
        <div className="rounded-lg  p-6 bg-blue-50">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Thông tin hội đồng
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div className="flex">
                <label className="w-32 text-sm font-medium text-gray-700">
                  Tên hội đồng:
                </label>
                <span className="text-sm text-gray-900">
                  Hội đồng xét duyệt đề tài số 1 năm 2025
                </span>
              </div>
              <div className="flex">
                <label className="w-32 text-sm font-medium text-gray-700">
                  Loại hội đồng:
                </label>
                <span className="text-sm text-gray-900">
                  Hội đồng xét duyệt thuyết minh đề cương
                </span>
              </div>
            </div>
            <div className="space-y-4">
              <div className="flex">
                <label className="w-32 text-sm font-medium text-gray-700">
                  Ngày quyết định:
                </label>
                <span className="text-sm text-gray-900">20/07/2025</span>
              </div>
              <div className="flex">
                <label className="w-32 text-sm font-medium text-gray-700">
                  Lĩnh vực đánh giá:
                </label>
                <span className="text-sm text-gray-900">
                  Công nghệ thông tin và tự động hóa
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Add Council Members Section */}
        <div className="bg-white rounded-lg border border-gray-200">
          <div className="p-6 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800">
              Thêm danh sách thành viên hội đồng
            </h2>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full border-collapse">
              <thead>
                <tr className="bg-gray-50">
                  <th className="border border-gray-300 px-3 py-2 text-sm font-bold text-black text-left w-16">
                    STT
                  </th>
                  <th className="border border-gray-300 px-3 py-2 text-sm font-bold text-black text-left">
                    Chọn thành viên hội đồng
                  </th>
                  <th className="border border-gray-300 px-3 py-2 text-sm font-bold text-black text-left">
                    Tên thành viên hội đồng
                  </th>
                  <th className="border border-gray-300 px-3 py-2 text-sm font-bold text-black text-left">
                    Vai trò
                  </th>
                  <th className="border border-gray-300 px-3 py-2 text-sm font-bold text-black text-center w-20">
                    Thao tác
                  </th>
                </tr>
              </thead>
              <tbody>
                {members.map((member, index) => (
                  <tr key={member.id} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-3 py-2 text-sm text-gray-900 text-center w-16">
                      {index + 1}
                    </td>
                    <td className="border border-gray-300 px-3 py-2">
                      <select
                        value={member.selectedMember}
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "selectedMember",
                            e.target.value
                          )
                        }
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      >
                        <option value="">- Chọn thành viên hội đồng -</option>
                        <option value="member1">Nguyễn Văn A</option>
                        <option value="member2">Trần Thị B</option>
                        <option value="member3">Lê Văn C</option>
                        <option value="member4">Phạm Thị D</option>
                        <option value="member5">Hoàng Văn E</option>
                      </select>
                    </td>
                    <td className="border border-gray-300 px-3 py-2">
                      <input
                        type="text"
                        value={member.memberName}
                        onChange={(e) =>
                          handleInputChange(index, "memberName", e.target.value)
                        }
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Nhập tên thành viên"
                      />
                    </td>
                    <td className="border border-gray-300 px-3 py-2">
                      <select
                        value={member.role}
                        onChange={(e) =>
                          handleInputChange(index, "role", e.target.value)
                        }
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      >
                        <option value="">- Chọn vai trò -</option>
                        <option value="Chủ tịch">Chủ tịch</option>
                        <option value="Phó chủ tịch">Phó chủ tịch</option>
                        <option value="Thư ký">Thư ký</option>
                        <option value="Ủy viên">Ủy viên</option>
                        <option value="Phản biện">Phản biện</option>
                      </select>
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-center w-20">
                      <button
                        type="button"
                        onClick={() => removeMember(index)}
                        className="p-1 text-red-500 hover:text-red-700 hover:bg-red-50 rounded transition-colors"
                        title="Xóa thành viên"
                        disabled={members.length === 1}
                      >
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Add Member Button */}
          <div className="p-4 border-t border-gray-200">
            <button
              type="button"
              onClick={addMember}
              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors"
            >
              <Plus className="h-4 w-4" />
              Thêm thành viên
            </button>
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default AddCouncilMember;
